export default __webpack_public_path__ + "static/media/icn-file-active.ecd9d006.svg";